/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable react/prop-types, max-len */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AddLayerPermissions.scss';

import ModalAlert from '../../../ModalAlert';
import { addLayerPermissions, deleteLayerPermissions, updateLayerPermissions } from '../../../../../actions/district';

const fastStyleMargin = {
  marginTop: '7px',
};

class AddLayerPermissions extends React.Component {
  constructor(props) {
    super(props);
    const i = 0;
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
      roleIndex: i,
      newLayerValue: '',
      currentRole: this.unpackRole(this.props.district.roles[i]),
      changedLayers: [],
      isEdited: false,
    };
  }

  unpackRole = role => {
    const newRole = {
      nazwa: role.nazwa,
      layers: [],
    };
    role.layers && role.layers.forEach((v) => {
      newRole.layers.push({
        r: v.r,
        w: v.w,
        d: v.d,
        layer: v.layer,
      });
    });

    return newRole;
  }

  onConfirm = () => {}
  onChangeRole = (e) => {
    this.setState({
      isEdited: false,
      roleIndex: e.target.selectedIndex,
      currentRole: this.unpackRole(this.props.district.roles[e.target.selectedIndex]),
    })};
  onChangeNewLayer = (e) => this.setState({ newLayerValue: e.target.value });
  dismissModal = () => this.setState({ showModal: false });
  dismissConfirm = () => this.setState({ showConfirm: false });

  addLayer = () => {
    const layer = _.find(this.props.district.layers, (o) => o.name === this.state.newLayerValue);
    this.props.addLayerPermissions(this.props.district.prefix, this.state.currentRole.nazwa, this.state.newLayerValue)
    .then((resp) => {
      this.setState({ currentRole: this.unpackRole(this.props.district.roles[this.state.roleIndex]) });
    });
  }

  delete = (nazwa) => {
    this.props.deleteLayerPermissions(this.props.district.prefix, this.state.currentRole.nazwa, nazwa)
    .then((resp) => {
      this.setState({ currentRole: this.unpackRole(this.props.district.roles[this.state.roleIndex]) });
    });
  }

  saveRolePermissions = () => {
    this.props.updateLayerPermissions(this.props.district.prefix, this.state.changedLayers, this.state.currentRole.nazwa)
    .then((resp) => {
      this.setState({ currentRole: this.unpackRole(this.props.district.roles[this.state.roleIndex]), changedLayers: [] });
    });
  }

  changeLayerPermissions = (e, v, i) => {

    // find layer in current role and change property
    const newLayersState = _.filter(this.state.currentRole.layers, (o) => {
      if (o.layer === v.layer) {
        const attr = e.target.name;
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        o[attr] = value;
        return o;
      }
      return o;
    });

    this.setState({
      currentRole: {
        ...this.state.currentRole,
        layers: newLayersState,
      },
    }, () => {
      const layer = _.find(this.props.district.roles[this.state.roleIndex].layers, (o) => o.layer === v.layer);
      const areLayersEqual = _.isEqual(this.props.district.roles[this.state.roleIndex].layers, this.state.currentRole.layers);
      const isLayerInList = _.find(this.state.changedLayers, (o) => o.layer === v.layer );
      if (!_.isEqual(layer, this.state.currentRole.layers[i])) {
        if (!isLayerInList) this.setState({ changedLayers: this.state.changedLayers.concat(v)});
      } else {
        if (isLayerInList) this.setState({ changedLayers: _.filter(this.state.changedLayers, (o) => o.layer !== v.layer )});
      }
      this.setState({ isEdited: !areLayersEqual });
    });
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          <div className="form-inline">
            <label htmlFor="selectRole" className="col-xs-3" style={fastStyleMargin}>Nazwa</label>
            <select
              name="selectRole"
              className="form-control"
              value={this.props.district.roles[this.state.roleIndex].nazwa}
              onChange={(e) => this.onChangeRole(e)}
            >
              {this.props.district.roles.map((v, i) => <option key={i} value={v.nazwa}>{v.nazwa}</option>)}
            </select>
          </div>
        </div>
        <div className="row">

          <h2>Uprawnienia do warstw:</h2>
          <p>Modyfikuj lub dodaj uprawnienia do wybranych warstw.</p>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Nazwa warstwy</th>
                <th>read</th>
                <th>write</th>
                <th>delete</th>
                <th>Akcje</th>
              </tr>
            </thead>
            <tbody>
              {this.state.currentRole.layers.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{v.layer}</td>
                    <td><input name="r" type="checkbox" checked={v.r} onChange={(e) => this.changeLayerPermissions(e, v, i)} /></td>
                    <td><input name="w" type="checkbox" checked={v.w} onChange={(e) => this.changeLayerPermissions(e, v, i)} /></td>
                    <td><input name="d" type="checkbox" checked={v.d} onChange={(e) => this.changeLayerPermissions(e, v, i)} /></td>
                    <td><button type="button" className="btn btn-danger" onClick={() => this.delete(v.layer)}>Usuń</button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="form-inline">
            <button type="button" className="btn btn-primary" onClick={() => this.addLayer()}>Dodaj warstwę</button>
            <select className="selectNewLayer" value={this.state.newLayerValue} onChange={(e) => this.onChangeNewLayer(e)}>
              <option />
              {this.props.district.layers && this.props.district.layers.map((v, i) => {
                const hasLayerPermissions = _.find(this.state.currentRole.layers, (o) => o.layer === v.name);
                return !hasLayerPermissions ? <option key={i} value={v.name}>{v.name}</option> : null;
              })}
            </select>
          </div>
        </div>
        {this.state.changedLayers.length > 0 ? (
          <div className="row">
            <button type="button" className="btn btn-warning" onClick={() => this.saveRolePermissions()}>Zapisz</button>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  addLayerPermissions,
  deleteLayerPermissions,
  updateLayerPermissions,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddLayerPermissions));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/AddLayerPermissions/AddLayerPermissions.js